import React from "react";

import { icon1x, icon2x, icon3x } from "../../assets/claim-your-home-icon";
import Tooltip from "../Tooltip";
import * as S from "./styled";

const HomeClaimHeader = () => (
  <>
    <S.HeaderContainer>
      <S.ClaimYourHomeIcon
        alt=""
        aria-hidden="true"
        srcSet={`${icon1x} 1x,
               ${icon2x} 2x,
               ${icon3x} 3x`}
      />
      <S.Heading>StreetEasy Valuation</S.Heading>
      <Tooltip title="What is the StreetEasy Valuation?">
        The StreetEasy Valuation is a beta product feature that gives
        StreetEasy&apos;s estimated market value. It is not an appraisal. Use it
        as a starting point to determine a home&apos;s value, and consider
        partnering with a listing agent to learn more.
      </Tooltip>
    </S.HeaderContainer>
    <S.Separator />
  </>
);

export default HomeClaimHeader;
